const config = {
  serverUrl: import.meta.env.VITE_APP_SERVER_URL,
  env: import.meta.env.VITE_APP_ENV,
  apiKey: import.meta.env.VITE_APP_API_KEY
};

export default config; 